import React from "react";
import { FormattedMessage } from "react-intl";

export const NavigationErrorMessage = (
  <FormattedMessage
    id="inbounds.navigation.navigationErrorMessage"
    defaultMessage="Step does not exist. Please refresh the page or contact support."
  />
);
